import { FC } from 'react';
import { Box } from '@qga/roo-ui/components';
import { ShowOnSmallScreen } from 'components/Layout';
import PropertyImage from 'components/PropertyImage';
import { DetailsBooking } from 'types';

interface MobileOnlyPropertyImageProps {
  booking: DetailsBooking;
}

const MobileOnlyPropertyImage: FC<MobileOnlyPropertyImageProps> = ({ booking }) => {
  return (
    <ShowOnSmallScreen>
      <Box>
        <PropertyImage {...booking.mediumImage} />
      </Box>
    </ShowOnSmallScreen>
  );
};

export default MobileOnlyPropertyImage;
